  (function () {
    var root = document.querySelector('[data-ot]');
    if (!root || root.__ecOtInit) return;
    root.__ecOtInit = true;
    var data = JSON.parse(root.querySelector('[data-ot-data]').textContent);
    var host = root.closest('.product__details');
    var unitWord = data.unit || 'Item';
    var shape = root.getAttribute('data-ot-shape') || 'square';
    var CAR_MAX = 12;
    var DRAWER_CHUNK = 24;

    function ecT(k) { return root.getAttribute('data-ot-i18n-' + k) || ''; }
    function ecTf(k, vars) {
      return ecT(k).replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, n) {
        return vars && vars.hasOwnProperty(n) ? String(vars[n]) : m;
      });
    }
    function esc(v) { return String(v).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }

    function sqY(w, h) {
      if (!(h > w)) return 50;
      var r = h / w;
      return Math.max(0, Math.min(100, 10 * r / (r - 1)));
    }
    function sqImg(im) {
      var ap = function () {
        if (im.naturalWidth) im.style.objectPosition = '50% ' + sqY(im.naturalWidth, im.naturalHeight).toFixed(1) + '%';
      };
      if (im.complete) ap(); else im.addEventListener('load', ap);
    }
    function sqBg(el, url) {
      var pr = new Image();
      pr.onload = function () {
        el.style.backgroundSize = 'cover';
        el.style.backgroundPosition = '50% ' + sqY(pr.width, pr.height).toFixed(1) + '%';
      };
      pr.src = url;
    }

    var EP = window.ECPool;
    var pk = EP.pk, powKey = EP.powKey, normPowers = EP.normPowers;
    var RX_FIELDS = ['sph', 'cyl', 'axis'];
    function rxKey(v) {
      return pk(String(v == null ? '' : v).replace(/\u2212/g, '-').replace(/\s+/g, ''));
    }
    function normRx(src) {
      if (!src) return null;
      var out = {};
      RX_FIELDS.forEach(function (f) {
        var raw = src[f], set = {};
        var arr = Array.isArray(raw) ? raw : String(raw == null ? '' : raw).split(',');
        arr.forEach(function (x) {
          var v = String(x).trim();
          if (v !== '') set[rxKey(v)] = 1;
        });
        out[f] = set;
      });
      out.stock = (src.stock && window.ECToricStock) ? window.ECToricStock.parse(src.stock) : null;
      return out;
    }
    function normItem(it) {
      if (it.pair) it.powers = normPowers(it.powers);
      if (it.rx) it.rx = normRx(it.rx);
      return it;
    }
    function fm(c) { return window.ECMoney(c, 'grouped'); }

    normItem(data.self);
    (data.offers || []).forEach(function (o) {
      if (o.pool) o.pool.forEach(normItem);
      if (o.gift) normItem(o.gift);
    });

    function defKey(it) {
      if (it.powers['0.00'] && it.powers['0.00'].a) return '0.00';
      var best = null, bd = 1e9;
      Object.keys(it.powers).forEach(function (k) {
        var e = it.powers[k];
        if (!e.a) return;
        var d = Math.abs(parseFloat(k));
        if (bd > d) { bd = d; best = k; }
      });
      return best || '0.00';
    }

    function mainSelects() {
      if (!host) return null;
      var all = host.querySelectorAll('.variant-picker-pairs select'), nat = [];
      for (var j = 0; j !== all.length; j++) { if (!root.contains(all[j])) nat.push(all[j]); }
      return nat.length === 2 ? nat : null;
    }
    function mainPowers() {
      var nat = mainSelects();
      if (!nat) return null;
      var op1 = nat[0].options[nat[0].selectedIndex];
      var op2 = nat[1].options[nat[1].selectedIndex];
      if (!op1 || !op2) return null;
      return {
        r: powKey(op1.getAttribute('data-title') || op1.textContent),
        l: powKey(op2.getAttribute('data-title') || op2.textContent)
      };
    }

    var POW_RE = /^-?\d+(\.\d+)?\s*(\(non\s*prescription\))?$/i;
    function mainSingleSelect() {
      if (!host || mainSelects()) return null;
      var all = host.querySelectorAll('select[id^="option"]');
      for (var j = 0; j !== all.length; j++) {
        var el = all[j];
        if (root.contains(el)) continue;
        if (POW_RE.test(String(el.value || '').trim())) return el;
      }
      return null;
    }
    function mainSingleKey() {
      var el = mainSingleSelect();
      return el ? powKey(el.value) : null;
    }
    function isPowerShaped(it) {
      if (it.pair || !it.v || it.v.length < 2) return false;
      var n = 0;
      for (var j = 0; j !== it.v.length; j++) { if (POW_RE.test(String(it.v[j].t).trim())) n++; }
      return n * 2 >= it.v.length;
    }
    function resolveSingle(it, key) {
      var hit = null;
      (it.v || []).forEach(function (x) { if (!hit && powKey(x.t) === key) hit = x; });
      return hit;
    }

    function mainSizeSelect() {
      var n = (data.self && data.self.sizeOpt) || 0;
      if (!host || !n) return null;
      var all = host.querySelectorAll('select#option' + n);
      for (var j = 0; j !== all.length; j++) { if (!root.contains(all[j])) return all[j]; }
      return null;
    }
    function mainSizeVal() {
      var el = mainSizeSelect();
      return el ? String(el.value || '').trim() : null;
    }
    function itemHasSize(it) {
      if (it.pair || !it.v) return false;
      for (var j = 0; j !== it.v.length; j++) { if (it.v[j].sz != null) return true; }
      return false;
    }
    function selfShape() {
      return String((data && data.nailShape) || '').trim().toLowerCase();
    }
    function resolveSize(it, val) {
      var sizeMatch = [];
      (it.v || []).forEach(function (x) { if (String(x.sz || '').trim() === val) sizeMatch.push(x); });
      if (!sizeMatch.length) return null;
      var sh = selfShape();
      if (sh) {
        for (var j = 0; j !== sizeMatch.length; j++) {
          if (String(sizeMatch[j].sh || '').trim().toLowerCase() === sh) return sizeMatch[j];
        }
        var shRe = new RegExp('\\b' + sh.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\b');
        for (var k = 0; k !== sizeMatch.length; k++) {
          if (shRe.test(String(sizeMatch[k].sh || '').trim().toLowerCase())) return sizeMatch[k];
        }
      }
      return sizeMatch[0];
    }

    function rxTargets() {
      if (!host) return [];
      var all = host.querySelectorAll('form [data-custom-option-target]'), out = [];
      for (var j = 0; j !== all.length; j++) {
        var el = all[j];
        if (root.contains(el)) continue;
        if (el.type === 'checkbox') continue;
        out.push(el);
      }
      return out;
    }
    function rxProps() {
      var props = {};
      rxTargets().forEach(function (el) {
        var m = /^properties\[(.+)\]$/.exec(el.name || '');
        if (!m) return;
        if (el.value === '') return;
        props[m[1]] = el.value;
      });
      return props;
    }

    var TORIC_TYPE = '1 pair (2 toric lenses)';
    var RX_MSG = ecT('rx-required');
    var RX_NAMES = {
      'sph': 1, 'cyl': 1, 'axis': 1,
      'sph (r)': 1, 'cyl (r)': 1, 'axis (r)': 1,
      'sph (l)': 1, 'cyl (l)': 1, 'axis (l)': 1
    };
    function rxName(n) {
      var m = /^properties\[(.+)\]$/.exec(n || '');
      return m ? m[1].trim().toLowerCase().replace(/\s+/g, ' ') : '';
    }
    function rxComplete() {
      var els = rxTargets(), n = 0;
      for (var j = 0; j !== els.length; j++) {
        if (!RX_NAMES[rxName(els[j].name)]) continue;
        n++;
        if (String(els[j].value || '').trim() === '') return false;
      }
      return n > 0;
    }
    function selfToric() { return !!(data.self && data.self.toric); }
    function isToricItem(it) {
      if (!it) return false;
      if (it.toric) return true;
      return /custom\s*toric/i.test(String(it.t || ''));
    }
    function rxPicked() {
      var out = [];
      rxTargets().forEach(function (el) {
        var nm = rxName(el.name);
        if (!RX_NAMES[nm]) return;
        var v = String(el.value || '').trim();
        if (v === '') return;
        out.push({ f: nm.replace(/\s*\([rl]\)$/, ''), k: rxKey(v) });
      });
      return out;
    }
    function rxStockOk(it, pairs) {
      var grid = it.rx && it.rx.stock;
      if (!grid) return true;
      return window.ECToricStock.checkProps(grid, rxProps(), pairs || 1).ok;
    }
    function rxSlotCount(o, it) {
      var n = 0;
      ((o && o.slots) || []).forEach(function (s) { if (s.it && s.it.h === it.h) n++; });
      return n || 1;
    }
    function rxCompat(it, pairs) {
      if (!it || !isToricItem(it)) return true;
      if (it.h !== data.self.h) {
        var sel = rxPicked();
        for (var j = 0; j !== sel.length; j++) {
          var set = it.rx && it.rx[sel[j].f];
          if (!set || !set[sel[j].k]) return false;
        }
      }
      return rxStockOk(it, pairs);
    }
    function toricAllowed(it) {
      if (!isToricItem(it)) return true;
      if (selfToric() || mode() === 'toric') return true;
      return it.h === data.self.h;
    }

    function nativeSelOpts() {
      if (!host) return null;
      var all = host.querySelectorAll('select[name^="options["]'), map = {}, n = 0;
      for (var j = 0; j !== all.length; j++) {
        if (root.contains(all[j])) continue;
        var m = /^options\[(.+)\]$/.exec(all[j].name || '');
        var nm = m ? m[1].trim().toLowerCase() : '';
        if (!nm) continue;
        map[nm] = String(all[j].value);
        n++;
      }
      return n ? map : null;
    }
    function mainSelOpts() {
      if (data.self && !data.self.pair) {
        var nat = nativeSelOpts();
        if (nat) return nat;
      }
      var form = host && host.querySelector('form[action*="/cart/add"]');
      var idEl = form && form.querySelector('[name="id"]');
      var vid = idEl && idEl.value;
      if (!vid || !data.self || data.self.pair || !data.self.v) return null;
      var names = data.self.opts || [];
      for (var j = 0; j !== data.self.v.length; j++) {
        var v = data.self.v[j];
        if (String(v.id) === String(vid) && v.o) {
          var map = {};
          for (var k = 0; k !== names.length; k++) {
            var nm = String(typeof names[k] === 'string' ? names[k] : (names[k] && names[k].name) || '').trim().toLowerCase();
            if (nm) map[nm] = v.o[k];
          }
          return map;
        }
      }
      return null;
    }
    function sharedNames(it) {
      var mo = mainSelOpts();
      if (!mo || !it || it.pair || !it.opts) return null;
      var out = [];
      for (var j = 0; j !== it.opts.length; j++) {
        var nm = String(it.opts[j] || '').trim().toLowerCase();
        if (nm && mo.hasOwnProperty(nm)) out.push({ idx: j, name: nm, val: mo[nm] });
      }
      return out.length ? out : null;
    }
    var LENS_OPTS = ['lens type', 'lens index'];
    function mainLens() {
      var mo = mainSelOpts();
      if (!mo) return null;
      var out = [];
      LENS_OPTS.forEach(function (nm) {
        if (mo.hasOwnProperty(nm) && mo[nm] != null && mo[nm] !== '') out.push({ name: nm, val: String(mo[nm]) });
      });
      return out.length ? out : null;
    }
    function lensMatches(it) {
      var ml = mainLens();
      if (!ml || !it || it.pair || !it.opts) return null;
      var idxs = [];
      for (var k = 0; k !== ml.length; k++) {
        var at = -1;
        for (var j = 0; j !== it.opts.length; j++) {
          if (String(it.opts[j] || '').trim().toLowerCase() === ml[k].name) { at = j; break; }
        }
        if (at === -1) return [];
        idxs.push(at);
      }
      return (it.v || []).filter(function (v) {
        if (!v.o) return false;
        for (var q = 0; q !== ml.length; q++) {
          if (String(v.o[idxs[q]]) !== ml[q].val) return false;
        }
        return true;
      });
    }
    function lensOk(it) {
      var lm = lensMatches(it);
      return lm === null || lm.length !== 0;
    }
    function resolveShared(it) {
      var sh = sharedNames(it);
      var lm = lensMatches(it);
      if (lm && !lm.length) return null;
      if (!sh) return lm ? lm[0] : null;
      var vs = lm || it.v || [];
      var act = [];
      for (var k = 0; k !== sh.length; k++) {
        var offered = false;
        for (var j = 0; j !== vs.length; j++) {
          if (vs[j].o && String(vs[j].o[sh[k].idx]) === String(sh[k].val)) { offered = true; break; }
        }
        if (offered) act.push(sh[k]);
      }
      if (!act.length) return lm ? lm[0] : null;
      for (var j2 = 0; j2 !== vs.length; j2++) {
        var v = vs[j2], ok = true;
        if (!v.o) continue;
        for (var k2 = 0; k2 !== act.length; k2++) {
          if (String(v.o[act[k2].idx]) !== String(act[k2].val)) { ok = false; break; }
        }
        if (ok) return v;
      }
      return lm ? lm[0] : null;
    }
    function refreshShared() {
      offers.forEach(function (o) {
        var touched = false;
        o.slots.forEach(function (sl) {
          if (!sl.it || sl.it.pair) return;
          var rv = resolveShared(sl.it);
          if (rv && String(sl.vid) !== String(rv.id)) { sl.vid = rv.id; touched = true; }
        });
        if (touched) recompute(o);
      });
    }

    function mode() {
      if (mainSelects()) return 'pair';
      if (rxTargets().length) return 'toric';
      return 'single';
    }

    function eligible(it) {
      if (it.pair) {
        var mp = mainPowers();
        if (!mp) return true;
        var r = it.powers[mp.r], l = it.powers[mp.l];
        return !!(r && r.a && l && l.a);
      }
      if (!lensOk(it)) return false;
      var mk = mainSingleKey();
      if (mk && isPowerShaped(it)) return !!resolveSingle(it, mk);
      var sv = mainSizeVal();
      if (sv && itemHasSize(it)) return !!resolveSize(it, sv);
      return true;
    }

    function resolveVid(it, fallback) {
      var vid = fallback;
      var shv = resolveShared(it);
      if (shv) vid = shv.id;
      var mk = mainSingleKey();
      if (mk && isPowerShaped(it)) {
        var rv = resolveSingle(it, mk);
        if (rv) vid = rv.id;
      }
      var sv = mainSizeVal();
      if (sv && itemHasSize(it)) {
        var rs = resolveSize(it, sv);
        if (rs) vid = rs.id;
      }
      return vid;
    }

    function mkSlot(it) {
      var s = { it: it, vid: null };
      if (!it.pair && it.v && it.v.length) {
        var base = it.v[0].id;
        if (it.cv) {
          it.v.forEach(function (x) { if (String(x.id) === String(it.cv)) base = x.id; });
        }
        s.vid = resolveVid(it, base);
      }
      return s;
    }

    var offers = (data.offers || []).map(function (o) {
      var slots = [];
      for (var n = 0; n !== o.items; n++) slots.push(mkSlot(data.self));
      var isGift = !!(o.gift || o.giftCol);
      if (isGift) {
        var gs = o.gift ? mkSlot(o.gift) : { it: null, vid: null };
        slots.push(gs);
      }
      return { i: o.i, title: o.title, items: o.items, paid: o.paid, pct: o.pct, amt: o.amt || 0, col: o.col, pool: o.pool, gift: o.gift || null, giftCol: o.giftCol || null, isGift: isGift, giftPool: o.gift ? [o.gift] : null, giftLoading: false, slots: slots, rendered: false, loading: false };
    });

    function isGiftIdx(o, idx) { return !!(o && o.isGift && idx === o.items); }

    var st = { active: null };
    root.__ecOtState = st;

    function slotPrice(s) {
      if (!s.it) return 0;
      if (s.it.pair) {
        var mp = mainPowers();
        var rk = mp ? mp.r : defKey(s.it), lk = mp ? mp.l : defKey(s.it);
        var r = s.it.powers[rk], l = s.it.powers[lk];
        return (r ? r.p : 0) + (l ? l.p : 0);
      }
      var p = 0;
      (s.it.v || []).forEach(function (x) { if (String(x.id) === String(s.vid)) p = x.p; });
      return p;
    }

    function setText(sel, txt) {
      var el = root.querySelector(sel);
      if (el) el.textContent = txt;
    }

    function totalOf(o) {
      var ps = o.slots.map(slotPrice);
      var sum = 0;
      ps.forEach(function (x) { sum += x; });
      if (o.isGift) {
        return { sum: sum, total: sum - (ps[o.items] || 0) };
      }
      var free = o.items - o.paid;
      if (free > 0) {
        var sorted = ps.slice().sort(function (a, b) { return a - b; });
        var cut = 0;
        for (var j = 0; j !== free; j++) cut += sorted[j] || 0;
        if (o.pct > 0) cut = Math.round(cut * o.pct / 100);
        return { sum: sum, total: sum - cut };
      }
      if (o.pct > 0) return { sum: sum, total: Math.round(sum * (100 - o.pct) / 100) };
      if (o.amt > 0) return { sum: sum, total: Math.max(0, sum - o.amt * 100) };
      return { sum: sum, total: sum };
    }

    function freeIdxs(o) {
      var set = {};
      if (o.isGift) { set[o.items] = true; return set; }
      var free = o.items - o.paid;
      if (!(free > 0)) return set;
      var pairs = o.slots.map(function (s, idx) { return { p: slotPrice(s), idx: idx }; });
      pairs.sort(function (a, b) { return a.p - b.p || a.idx - b.idx; });
      for (var j = 0; j !== free; j++) { if (pairs[j]) set[pairs[j].idx] = true; }
      return set;
    }

    function paintPrices(o) {
      var fset = freeIdxs(o);
      var els = root.querySelectorAll('[data-ot-slots="' + o.i + '"] [data-ot-sp]');
      for (var j = 0; j !== els.length; j++) {
        var el = els[j];
        var idx = Number(el.getAttribute('data-ot-sp'));
        var s = o.slots[idx];
        if (!s) continue;
        var base = slotPrice(s);
        var cmp = null, txt = fm(base), bold = false;
        if (fset[idx]) {
          cmp = base > 0 ? base : null;
          if (o.pct > 0) { txt = fm(Math.round(base * (100 - o.pct) / 100)); }
          else { txt = ecT('free'); }
          bold = true;
        }
        else if (!(o.items - o.paid > 0) && o.pct > 0) {
          cmp = base; txt = fm(Math.round(base * (100 - o.pct) / 100)); bold = true;
        }
        el.textContent = '';
        if (cmp !== null) {
          var cs = document.createElement('s');
          cs.className = 't-opacity-70';
          cs.textContent = fm(cmp);
          el.appendChild(cs);
        }
        var pv = document.createElement('span');
        if (bold) pv.className = (fset[idx] && !(o.pct > 0)) ? 'ec-ot__sale ec-ot__free' : 'ec-ot__sale';
        pv.textContent = txt;
        el.appendChild(pv);
      }
    }

    var atcOrig = null;
    function atcTextEl() {
      if (!host) return null;
      var btn = host.querySelector('[name=add]');
      return btn ? btn.querySelector('[data-add-to-cart-text]') : null;
    }
    function updateAtc() {
      var el = atcTextEl();
      if (!el) return;
      if (!st.active) {
        if (atcOrig !== null) { el.textContent = atcOrig; atcOrig = null; }
        return;
      }
      if (atcOrig === null) atcOrig = el.textContent;
      el.textContent = ecTf('atc-with-total', { label: atcOrig.trim(), total: fm(totalOf(st.active).total) });
    }

    function recompute(o) {
      var r = totalOf(o);
      var per = Math.round(r.total / o.items);
      var free = o.items - o.paid;
      setText('[data-ot-total="' + o.i + '"]', fm(r.total));
      setText('[data-ot-cmp="' + o.i + '"]', r.total !== r.sum ? fm(r.sum) : '');
      var saveEl = root.querySelector('[data-ot-save="' + o.i + '"]');
      if (saveEl) {
        var saveWholeC = r.sum > r.total ? Math.floor((r.sum - r.total) / 100) * 100 : 0;
        if (r.sum > 0 && saveWholeC > 0) {
          setText('[data-ot-save-txt="' + o.i + '"]', ecTf('save', { amount: fm(saveWholeC) }));
          saveEl.hidden = false;
        } else {
          saveEl.hidden = true;
        }
      }
      setText('[data-ot-sub="' + o.i + '"]', ecTf('per-unit', { price: fm(per), unit: unitWord }));
      paintPrices(o);
      if (st.active === o) updateAtc();
    }

    var colCache = {};

    var TO_ITEM_OPTS = {
      pairType: '1 pair (2 lenses)',
      toricType: TORIC_TYPE,
      thumbModel: !!data.thumbModel,
      price: true,
      opts: true,
      optionFields: [
        { name: 'size', field: 'sz' },
        { name: 'nail shape', field: 'sh' }
      ]
    };
    function toItem(p) { return EP.toItem(p, TO_ITEM_OPTS); }

    function ensureCollection(o, gift) {
      if (gift) {
        if (!o.isGift || o.gift) return;
        if (o.giftPool && o.giftPool.length) return;
      } else if (o.pool && o.pool.length) return;
      var handle = gift ? o.giftCol : o.col;
      if (!handle) {
        if (gift) o.giftPool = [];
        else o.pool = o.pool || [];
        return;
      }
      if (colCache[handle]) {
        if (gift) { o.giftPool = colCache[handle]; seedGiftSlot(o); }
        else o.pool = colCache[handle];
        return;
      }
      if (gift ? o.giftLoading : o.loading) return;
      if (gift) o.giftLoading = true; else o.loading = true;
      EP.loadCollection(handle)
        .then(function (d) {
          var wantRx = (selfToric() || mode() === 'toric') && d.products.some(function (p) { return p.product_type === TORIC_TYPE; });
          if (!wantRx) return { d: d, rx: null };
          return EP.loadRxRanges(handle).then(
            function (rx) { return { d: d, rx: rx }; },
            function () { return { d: d, rx: null }; }
          );
        })
        .then(function (res) {
          var d = res.d;
          var items = [];
          d.products.forEach(function (p) {
            if (p.tags && p.tags.indexOf('hidden-item') !== -1) return;
            if (!p.images || !p.images.length) return;
            if (!p.variants.some(function (v) { return v.available; })) return;
            var it = toItem(p);
            if (res.rx && res.rx[p.handle]) it.rx = normRx(res.rx[p.handle]);
            items.push(it);
          });
          colCache[handle] = items;
          if (gift) {
            o.giftPool = items;
            o.giftLoading = false;
            seedGiftSlot(o);
          } else {
            o.pool = items;
            o.loading = false;
          }
          if (o.rendered) renderSlots(o);
          if (st.active === o) recompute(o);
          var dc = drawer.ctx();
          if (dc && dc.o === o) {
            if (!gift) drawer.render(drawerSource());
            else if (isGiftIdx(o, dc.idx)) drawer.render(eligibleGiftPool(o));
          }
        })
        .catch(function () {
          if (gift) { o.giftLoading = false; o.giftPool = []; }
          else { o.loading = false; o.pool = []; }
          if (o.rendered) renderSlots(o);
        });
    }

    function eligiblePool(o) {
      var list = (o.pool || []).slice();
      var hasSelf = false;
      list.forEach(function (x) { if (x.h === data.self.h) hasSelf = true; });
      if (!hasSelf) list.unshift(data.self);
      return list.filter(function (x) { return eligible(x) && toricAllowed(x) && rxCompat(x); });
    }

    function eligibleGiftPool(o) {
      return (o.giftPool || []).filter(function (x) { return eligible(x) && toricAllowed(x) && rxCompat(x); });
    }

    function seedGiftSlot(o) {
      var s = o.slots[o.items];
      if (!s || s.it) return;
      var list = eligibleGiftPool(o);
      if (!list.length) return;
      var seeded = mkSlot(list[0]);
      s.it = seeded.it;
      s.vid = seeded.vid;
    }

    function noticeDim(it) {
      if (mainSizeVal() && itemHasSize(it)) return 'size';
      if (!lensOk(it)) return 'lens';
      return 'power';
    }
    function sweep(o) {
      var changed = false;
      o.slots.forEach(function (s, idx) {
        if (s.lost && eligible(s.lost)) s.lost = null;
        if (!s.it || idx === 0 || eligible(s.it)) return;
        var next = isGiftIdx(o, idx) ? eligibleGiftPool(o)[0] : data.self;
        if (!next || next.h === s.it.h) return;
        var ns = mkSlot(next);
        s.lost = s.it;
        s.it = ns.it;
        s.vid = ns.vid;
        changed = true;
      });
      return changed;
    }

    function pickItem(o, idx, it) {
      var s = o.slots[idx];
      s.lost = null;
      s.it = it;
      if (it.pair) s.vid = null;
      else s.vid = resolveVid(it, it.v && it.v[0] ? it.v[0].id : null);
      updateSlot(o, idx);
      recompute(o);
    }

    function updateSlot(o, idx) {
      var row = root.querySelector('[data-ot-slots="' + o.i + '"] [data-ot-slot="' + idx + '"]');
      if (!row) { renderSlots(o); return; }
      var s = o.slots[idx];
      if (!s.it) { renderSlots(o); return; }
      var im = row.querySelector('.ec-ot__thumb');
      if (im) { im.alt = s.it.t; if (s.it.img) { im.src = s.it.img; sqImg(im); } }
      var tt = row.querySelector('.ec-ot__slot-title');
      if (tt) tt.textContent = s.it.t;
      var no = row.querySelector('.ec-ot__notice');
      if (no && !s.lost && eligible(s.it) && rxCompat(s.it, rxSlotCount(o, s.it))) no.parentNode.removeChild(no);
      var chips = row.querySelectorAll('[data-ot-pick]');
      for (var j = 0; j !== chips.length; j++) {
        chips[j].classList.toggle('selected', chips[j].getAttribute('data-ot-h') === s.it.h);
      }
      var old = row.querySelector('.ec-ot__vsel');
      if (old) old.parentNode.removeChild(old);
      if (!s.it.pair && s.it.v && s.it.v.length > 1 && mode() !== 'toric' && !(mainSingleKey() && isPowerShaped(s.it)) && !(mainSizeVal() && itemHasSize(s.it))) {
        var bodyEl = row.querySelector('.ec-ot__slot-body');
        if (bodyEl) bodyEl.appendChild(vselFor(o, s));
      }
    }

    function carousel(o, s, idx) {
      var wrap = document.createElement('div');
      wrap.className = 'product__color-swatches ec-ot__swatches';
      var inner = document.createElement('div');
      inner.className = 'product__color-swatches--inner';
      wrap.appendChild(inner);
      var giftCar = isGiftIdx(o, idx);
      if (giftCar ? o.giftLoading : o.loading) {
        inner.innerHTML = '<span class="fs-body-75">' + esc(ecT('loading')) + '</span>';
        return { el: wrap, count: 0 };
      }
      var list = giftCar ? eligibleGiftPool(o) : eligiblePool(o);
      if (!giftCar && mainLens() && (!list.length || (list.length === 1 && list[0].h === data.self.h))) {
        return { el: null, count: 0 };
      }
      if (!list.length) {
        inner.innerHTML = '<span class="fs-body-75">' + esc(ecT('no-options-power')) + '</span>';
        return { el: wrap, count: 0 };
      }
      var fr = (s.fr || []).map(function (h) {
        for (var q = 0; q !== list.length; q++) if (list[q].h === h) return list[q];
        return null;
      }).filter(Boolean);
      fr.concat(list.slice(0, CAR_MAX).filter(function (x) { return fr.indexOf(x) === -1; })).forEach(function (it) {
        var opt = document.createElement('div');
        opt.className = 'ec-ot__opt';
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'product__color-swatch product__color-swatch--sibling-product' + (it.h === s.it.h ? ' selected' : '');
        b.setAttribute('data-ot-pick', '');
        b.setAttribute('data-ot-h', it.h);
        b.setAttribute('data-shape', shape);
        b.setAttribute('aria-label', it.t);
        b.title = it.t;
        if (it.img) { var sw = it.img.replace(/_400x(?=\.)/, '_200x'); b.style.backgroundImage = 'url(' + sw + ')'; sqBg(b, sw); }
        b.addEventListener('click', function (ev) { ev.preventDefault(); pickItem(o, idx, it); });
        opt.appendChild(b);
        inner.appendChild(opt);
      });
      return { el: wrap, count: list.length };
    }

    function vselFor(o, s) {
      var sv = document.createElement('select');
      sv.className = 'input ec-ot__vsel';
      (lensMatches(s.it) || s.it.v).forEach(function (x) {
        var op = document.createElement('option');
        op.value = String(x.id);
        op.textContent = x.t;
        sv.appendChild(op);
      });
      sv.value = String(s.vid);
      sv.addEventListener('change', function () {
        s.vid = sv.value;
        recompute(o);
      });
      return sv;
    }

    function slotRow(o, s, idx) {
      var d = document.createElement('div');
      d.className = 'ec-ot__slot';
      d.setAttribute('data-ot-slot', String(idx));
      if (!s.it) {
        var ld = document.createElement('span');
        ld.className = 'fs-body-75 t-opacity-70';
        ld.textContent = ecT('loading-gift');
        d.appendChild(ld);
        return d;
      }
      var im = document.createElement('img');
      im.className = 'ec-ot__thumb';
      im.alt = s.it.t;
      im.loading = 'lazy';
      if (s.it.img) { im.src = s.it.img; sqImg(im); }
      d.appendChild(im);
      var body = document.createElement('div');
      body.className = 'ec-ot__slot-body';
      var top = document.createElement('div');
      top.className = 'ec-ot__slot-top';
      var num = document.createElement('span');
      num.className = 'ec-ot__slot-num fs-body-75 t-opacity-70';
      num.textContent = '#' + (idx + 1);
      var tt = document.createElement('span');
      tt.className = 'ec-ot__slot-title fs-body-100';
      tt.textContent = s.it.t;
      var pr = document.createElement('span');
      pr.className = 'ec-ot__slot-price fs-body-100';
      pr.setAttribute('data-ot-sp', String(idx));
      top.appendChild(num); top.appendChild(tt); top.appendChild(pr);
      body.appendChild(top);
      var bad = !eligible(s.it) || !rxCompat(s.it, rxSlotCount(o, s.it));
      if (bad || s.lost) {
        var dim = noticeDim(bad ? s.it : s.lost);
        var no = document.createElement('p');
        no.className = 'ec-ot__notice fs-body-75';
        no.textContent = (bad && idx === 0)
          ? ecT('unavailable-self-' + dim)
          : ecT('unavailable-other-' + dim);
        body.appendChild(no);
      }var giftSlot = isGiftIdx(o, idx);
      var wantsPicker = giftSlot ? !!o.giftCol : idx !== 0;
      if (wantsPicker) {
        var car = carousel(o, s, idx);
        if (car.el) body.appendChild(car.el);
        if (car.count > 10) {
          var br = document.createElement('button');
          br.type = 'button';
          br.className = 'btn btn--text-link ec-ot__browse';
          br.textContent = ecT('browse-all-options');
          br.addEventListener('click', function (ev) { ev.preventDefault(); openDrawer(o, idx); });
          body.appendChild(br);
        }
      }
      if (!s.it.pair && s.it.v && s.it.v.length > 1 && mode() !== 'toric' && !(mainSingleKey() && isPowerShaped(s.it)) && !(mainSizeVal() && itemHasSize(s.it))) {
        body.appendChild(vselFor(o, s));
      }
      d.appendChild(body);
      return d;
    }

    function renderSlots(o) {
      var c = root.querySelector('[data-ot-slots="' + o.i + '"]');
      if (!c) return;
      var keep = {};
      var olds = c.querySelectorAll('[data-ot-slot]');
      for (var j = 0; j !== olds.length; j++) {
        var inn = olds[j].querySelector('.product__color-swatches--inner');
        if (inn && inn.scrollLeft > 0) keep[olds[j].getAttribute('data-ot-slot')] = inn.scrollLeft;
      }
      c.innerHTML = '';
      o.slots.forEach(function (s, idx) { c.appendChild(slotRow(o, s, idx)); });
      var news = c.querySelectorAll('[data-ot-slot]');
      for (var k = 0; k !== news.length; k++) {
        var kept = keep[news[k].getAttribute('data-ot-slot')];
        if (kept) {
          var inn2 = news[k].querySelector('.product__color-swatches--inner');
          if (inn2) inn2.scrollLeft = kept;
        }
      }
      paintPrices(o);
    }

    root.addEventListener('change', function (e) {
      var rd = e.target.closest ? e.target.closest('[data-ot-radio]') : null;
      if (!rd) return;
      var val = rd.value;
      offers.forEach(function (o) {
        var on = String(o.i) === val;
        var sc = root.querySelector('[data-ot-slots="' + o.i + '"]');
        if (sc) { sc.classList.toggle('is-in', on && sc.hidden && e.isTrusted); sc.hidden = !on; }
        var wrap = root.querySelector('[data-ot-offer="' + o.i + '"]');
        if (wrap) wrap.classList.toggle('is-on', on);
        if (on) {
          if (!o.rendered) { o.rendered = true; ensureCollection(o, false); ensureCollection(o, true); renderSlots(o); }
          st.active = o;
          recompute(o);
        }
      });
      if (val === '0') st.active = null;
      updateAtc();
      var r1 = root.querySelector('[data-ot-row1]');
      if (r1) r1.classList.toggle('is-on', val === '0');
      var errEl = root.querySelector('[data-ot-err]');
      if (errEl) errEl.hidden = true;
    });

    var drawer = EP.Drawer(root, {
      chunk: DRAWER_CHUNK,
      emptyHtml: '<span class="fs-body-75">' + esc(ecT('nothing-in-power')) + '</span>',
      card: function (it) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'ec-pd__item';
        b.setAttribute('data-title', it.t.toLowerCase());
        var im = document.createElement('img');
        im.loading = 'lazy';
        im.alt = it.t;
        if (it.img) { im.src = it.img; sqImg(im); }
        var nm = document.createElement('span');
        nm.className = 'ec-pd__name';
        nm.textContent = it.t;
        b.appendChild(im); b.appendChild(nm);
        b.addEventListener('click', function () { drawer.pick(it); });
        return b;
      },
      title: function (c) {
        return isGiftIdx(c.o, c.idx) ? ecT('choose-free-gift') : ecTf('choose-item', { number: c.idx + 1 });
      },
      onOpen: function (c) {
        if (isGiftIdx(c.o, c.idx) ? c.o.giftLoading : c.o.loading) {
          drawer.setMessage('<span class="fs-body-75">' + esc(ecT('loading')) + '</span>');
          return;
        }
        drawer.render(drawerSource());
      },
      searchBase: function () { return drawerSource(); },
      clearSource: function () { return drawerSource(); },
      onPick: function (it, c) { pickItem(c.o, c.idx, it); frontPick(c.o, c.idx, it); }
    });

    function frontPick(o, idx, it) {
      var row = root.querySelector('[data-ot-slots="' + o.i + '"] [data-ot-slot="' + idx + '"]');
      var wrap = row && row.querySelector('.ec-ot__swatches');
      if (!wrap) return;
      var inner = wrap.querySelector('.product__color-swatches--inner');
      var bs = wrap.querySelectorAll('[data-ot-pick]');
      for (var j = 0; j !== bs.length; j++) {
        if (bs[j].getAttribute('data-ot-h') !== it.h) continue;
        var a = bs[j].getBoundingClientRect(), b = inner.getBoundingClientRect();
        if (a.left < b.left || a.right > b.right) inner.scrollLeft += a.left - b.left;
        return;
      }
      var s = o.slots[idx];
      s.fr = [it.h].concat((s.fr || []).filter(function (h) { return h !== it.h; }));
      var car = carousel(o, s, idx);
      if (!car.el) return;
      wrap.parentNode.replaceChild(car.el, wrap);
      car.el.querySelector('.product__color-swatches--inner').scrollLeft = 0;
    }

    function drawerSource() {
      var c = drawer.ctx();
      if (!c) return [];
      return isGiftIdx(c.o, c.idx) ? eligibleGiftPool(c.o) : eligiblePool(c.o);
    }

    function openDrawer(o, idx) { drawer.open({ o: o, idx: idx }); }

    function rxRefresh() {
      offers.forEach(function (o) {
        o.slots.forEach(function (s, idx) {
          if (!s.it || rxCompat(s.it)) return;
          var next = isGiftIdx(o, idx) ? eligibleGiftPool(o)[0] : data.self;
          if (!next) return;
          var ns = mkSlot(next);
          s.it = ns.it;
          s.vid = ns.vid;
        });
        if (o.isGift) seedGiftSlot(o);
        if (o.rendered) renderSlots(o);
        if (st.active === o) recompute(o);
      });
      if (drawer.ctx()) drawer.render(drawerSource());
    }

    var lensSig = null;
    function lensKey() {
      var ml = mainLens();
      return ml ? ml.map(function (x) { return x.val; }).join('|') : '';
    }
    function lensRefresh() {
      var sig = lensKey();
      if (sig === lensSig) return;
      lensSig = sig;
      offers.forEach(function (o) {
        sweep(o);
        if (o.rendered) renderSlots(o);
        if (st.active === o) recompute(o);
      });
      if (drawer.ctx()) drawer.render(drawerSource());
    }
    lensSig = lensKey();

    function selfIdPrice() {
      var m = {};
      if (data.self.pair) {
        Object.keys(data.self.powers).forEach(function (k) {
          var e = data.self.powers[k];
          m[String(e.id)] = e.p;
        });
      } else {
        (data.self.v || []).forEach(function (x) { m[String(x.id)] = x.p; });
      }
      return m;
    }
    var idp = selfIdPrice();

    document.addEventListener('product:variant-change', function (e) {
      var v = e.detail && e.detail.variant;
      if (!v || typeof v.price !== 'number') return;
      if (!idp.hasOwnProperty(String(v.id))) return;
      var p1 = root.querySelector('[data-ot-p1]');
      if (p1) p1.textContent = fm(v.price * data.pairQty);
      setTimeout(refreshShared, 60);
      setTimeout(lensRefresh, 100);
      if (st.active) setTimeout(updateAtc, 120);
    });

    if (host) {
      host.addEventListener('change', function (e) {
        var sel = e.target;
        if (!sel || root.contains(sel)) return;
        setTimeout(refreshShared, 80);
        setTimeout(lensRefresh, 100);
        if (sel.tagName !== 'SELECT') return;
        if (sel.hasAttribute('data-custom-option-input') || sel.hasAttribute('data-custom-option-target')) rxRefresh();
        if (!sel.closest('.variant-picker-pairs')) {
          var isPow = sel === mainSingleSelect();
          var isSz = sel === mainSizeSelect();
          if (!isPow && !isSz) return;
          var mk = mainSingleKey();
          var sv = mainSizeVal();
          offers.forEach(function (o) {
            (o.slots || []).forEach(function (s) {
              if (s.it.pair) return;
              if (isPow && mk && isPowerShaped(s.it)) {
                var rv = resolveSingle(s.it, mk);
                if (rv) s.vid = rv.id;
              }
              if (isSz && sv && itemHasSize(s.it)) {
                var rs = resolveSize(s.it, sv);
                if (rs) s.vid = rs.id;
              }
            });
            sweep(o);
            if (o.rendered) renderSlots(o);
            if (st.active === o) recompute(o);
          });
          if (st.active) setTimeout(updateAtc, 120);
          return;
        }
        var nat = mainSelects();
        if (!nat) return;
        var a = idp[String(nat[0].value)], b = idp[String(nat[1].value)];
        var p1 = root.querySelector('[data-ot-p1]');
        if (p1 && typeof a === 'number' && typeof b === 'number') p1.textContent = fm(a + b);
        offers.forEach(function (o) {
          sweep(o);
          if (o.rendered) renderSlots(o);
          if (st.active === o) recompute(o);
        });
        if (st.active) setTimeout(updateAtc, 120);
      });
    }

    function buildItems(o) {
      var md = mode();
      var props = md === 'toric' ? rxProps() : null;
      var mp = mainPowers();
      var items = [], base = Date.now(), bad = [], lines = [];
      var ack = ackProps();
      var needRx = selfToric();
      o.slots.forEach(function (s) { if (isToricItem(s.it)) needRx = true; });
      if (needRx && !rxComplete()) return { items: [], bad: [], rxBad: true };
      o.slots.forEach(function (s, idx) {
        if (!s.it) { bad.push({ why: 'power', txt: isGiftIdx(o, idx) ? ecT('gift-loading-short') : ecTf('slot-label', { unit: unitWord, number: idx + 1 }) }); return; }
        var fail = function (why) { bad.push({ why: why || badDim(s.it), txt: ecTf('slot-label-titled', { unit: unitWord, number: idx + 1, title: s.it.t }) }); };
        var put = function (line, label) { items.push(line); lines.push({ id: String(line.id), slot: idx + 1, title: s.it.t, label: label }); };
        if (!lensOk(s.it)) { fail('lens'); return; }
        if (md === 'toric') {
          if (!rxCompat(s.it, rxSlotCount(o, s.it))) { fail(isToricItem(s.it) ? 'rx' : null); return; }
          var tvid = s.vid;
          if (sharedNames(s.it) || lensMatches(s.it)) {
            var shr = resolveShared(s.it);
            if (!shr) { fail(); return; }
            tvid = shr.id;
          }
          if (!tvid && s.it.v && s.it.v[0]) tvid = s.it.v[0].id;
          if (!tvid && s.it.pair) { var dk = defKey(s.it); tvid = s.it.powers[dk] && s.it.powers[dk].id; }
          if (!tvid) { fail(); return; }
          var line = { id: Number(tvid), quantity: 1 };
          if (props && Object.keys(props).length) line.properties = props;
          put(withAck(line, ack, isGiftIdx(o, idx)), vLabel(s.it, tvid));
        } else if (s.it.pair) {
          var rk = mp ? mp.r : defKey(s.it), lk = mp ? mp.l : defKey(s.it);
          var r = s.it.powers[rk], l = s.it.powers[lk];
          if (!r || !r.a || !l || !l.a) { fail(); return; }
          var pid = base + idx;
          put(withAck({ quantity: 1, id: r.id, properties: { 'Power R': r.label, 'Power L': l.label, '_pair': 'true', '_pair_id': pid, '_eye': 'R' } }, ack, isGiftIdx(o, idx)), r.label);
          put(withAck({ quantity: 1, id: l.id, properties: { 'Power R': r.label, 'Power L': l.label, '_pair': 'true', '_pair_id': pid, '_eye': 'L' } }, ack, isGiftIdx(o, idx)), l.label);
        } else {
          var vid = s.vid || (s.it.v && s.it.v[0] && s.it.v[0].id);
          var mk = mainSingleKey();
          if (mk && isPowerShaped(s.it)) {
            var rv = resolveSingle(s.it, mk);
            if (!rv) { fail(); return; }
            vid = rv.id;
          }
          var sv = mainSizeVal();
          if (sv && itemHasSize(s.it)) {
            var rs = resolveSize(s.it, sv);
            if (!rs) { fail(); return; }
            vid = rs.id;
          }
          var lmv = lensMatches(s.it);
          if (lmv && !lmv.some(function (x) { return String(x.id) === String(vid); })) vid = lmv[0].id;
          if (!vid) { fail(); return; }
          put(withAck({ id: Number(vid), quantity: 1 }, ack, isGiftIdx(o, idx)), vLabel(s.it, vid));
        }
      });
      return { items: items, bad: bad, lines: lines };
    }

    function badDim(it) { return noticeDim(it); }
    function vLabel(it, vid) {
      var out = '';
      (it.v || []).forEach(function (x) { if (String(x.id) === String(vid)) out = String(x.t || ''); });
      return out;
    }
    function cleanLabel(label) {
      var l = String(label || '').trim();
      if (/^default title$/i.test(l)) return '';
      return l.replace(/\s*\([^)]*\)\s*$/, '').trim();
    }

    function showBadSlots(err, bad) {
      var by = {}, order = [];
      bad.forEach(function (b) {
        if (!by[b.why]) { by[b.why] = []; order.push(b.why); }
        by[b.why].push(b.txt);
      });
      err.textContent = order.map(function (w) { return ecTf('bad-slots-' + w, { items: by[w].join(', ') }); }).join(' ');
      err.hidden = false;
    }

    var REJECT_RES = [
      /^The product '(.+)' is already sold out\.?$/i,
      /^You can only add \d+ (?:of )?(.+?) to (?:the|your) cart\.?$/i,
      /^All \d+ (.+?) are in your cart\.?$/i
    ];
    function rejectedName(desc) {
      for (var j = 0; j !== REJECT_RES.length; j++) {
        var m = REJECT_RES[j].exec(desc);
        if (m) return m[1];
      }
      return null;
    }
    function rejectedGroup(name, lines) {
      var groups = {}, best = null, bestScore = 0;
      (lines || []).forEach(function (ln) {
        var g = groups[ln.id] || (groups[ln.id] = { title: ln.title, label: ln.label, slots: [] });
        if (g.slots.indexOf(ln.slot) === -1) g.slots.push(ln.slot);
        g.n = (g.n || 0) + 1;
      });
      Object.keys(groups).forEach(function (id) {
        var g = groups[id];
        var raw = String(g.label || '').trim();
        if (name.indexOf(g.title) === -1) return;
        var plain = !raw || /^default title$/i.test(raw);
        var tail = ' - ' + raw;
        if (!plain && name.slice(-tail.length) !== tail) return;
        var score = (plain ? 1 : 1000) + g.n;
        if (score > bestScore) { bestScore = score; best = g; }
      });
      return best;
    }
    function showAddError(err, e, lines) {
      var body = e && e.status === 422 ? e.body : null;
      var desc = body ? String(body.description || body.message || '').trim() : '';
      var name = desc ? rejectedName(desc) : null;
      var msg = '';
      if (name) {
        var g = rejectedGroup(name, lines);
        if (!g) {
          msg = ecTf('insufficient', { product: name });
        } else {
          var cl = cleanLabel(g.label);
          var product = cl ? g.title + ' ' + cl : g.title;
          var slots = g.slots.slice().sort(function (a, b) { return a - b; });
          if (slots.length > 1 && slots[0] === 1) slots.shift();
          if (slots.length === 1) {
            msg = ecTf('insufficient-one', { product: product, number: slots[0] });
          } else {
            var tags = slots.map(function (n) { return ecTf('slot-number', { number: n }); });
            var last = tags.pop();
            msg = ecTf('insufficient-many', { product: product, slots: tags.join(', '), last: last });
          }
        }
      } else if (desc && !/\d/.test(desc)) {
        msg = desc;
      }
      err.textContent = msg || ecT('error-generic');
      err.hidden = false;
    }
    function addItems(items) {
      return UTILS.EcCart.addItems(items).then(function (r) {
        if (r.ok) return r.json();
        return r.json().then(function (b) { return b; }, function () { return null; }).then(function (b) {
          var e = new Error('add failed');
          e.status = r.status;
          e.body = b;
          throw e;
        });
      });
    }

    function checksBlocked() {
      var f = host && host.querySelector('form[data-ec-required-checks="true"]');
      return !!(f && window.ECRequiredChecks && window.ECRequiredChecks.block(null, f));
    }
    function lensRxBlocked() {
      var f = host && host.querySelector('form[action*="/cart/add"]');
      return !!(f && f.__ecLensRxBlocked && f.__ecLensRxBlocked());
    }
    function ackProps() {
      var f = host && host.querySelector('form[data-ec-required-checks="true"]');
      return (f && window.ECRequiredChecks && window.ECRequiredChecks.props) ? window.ECRequiredChecks.props(f) : {};
    }
    function withAck(line, ack, gift) {
      if (gift || !Object.keys(ack).length) return line;
      line.properties = Object.assign({}, line.properties || {}, ack);
      return line;
    }

    st.submit = function (btn) {
      var o = st.active;
      if (!o) return;
      if (btn.classList.contains('loading')) return;
      var err = root.querySelector('[data-ot-err]');
      err.hidden = true;
      if (lensRxBlocked()) return;
      var built = buildItems(o);
      if (built.rxBad) { err.textContent = RX_MSG; err.hidden = false; return; }
      if (checksBlocked()) return;
      if (built.bad.length) { showBadSlots(err, built.bad); return; }
      btn.classList.add('loading');
      addItems(built.items)
        .then(function () {
          btn.classList.remove('loading');
          return UTILS.EcCart.refreshCart();
        })
        .catch(function (e) {
          btn.classList.remove('loading');
          showAddError(err, e, built.lines);
        });
    };

    st.buyItNow = function (pw) {
      var o = st.active;
      if (!o) return;
      if (pw.getAttribute('aria-busy') === 'true') return;
      var err = root.querySelector('[data-ot-err]');
      err.hidden = true;
      if (lensRxBlocked()) return;
      var built = buildItems(o);
      if (built.rxBad) { err.textContent = RX_MSG; err.hidden = false; return; }
      if (checksBlocked()) return;
      if (built.bad.length) { showBadSlots(err, built.bad); return; }
      pw.setAttribute('aria-busy', 'true');
      pw.style.opacity = '0.5';
      addItems(built.items)
        .then(function () {
          return fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: { 'checkout_method': 'buy_it_now' } })
          });
        })
        .then(function () { window.location.href = '/checkout'; })
        .catch(function (e) {
          pw.removeAttribute('aria-busy');
          pw.style.opacity = '';
          showAddError(err, e, built.lines);
        });
    };

    if (!window.__ecOtClickBound) {
      window.__ecOtClickBound = true;
      document.addEventListener('click', function (e) {
        var t = e.target;
        if (!t || !t.closest) return;
        var btn = t.closest('[name=add]');
        if (!btn) return;
        if (btn.closest('.quick-product--wrap')) return;
        var h = btn.closest('.product__details');
        if (!h) return;
        var r = h.querySelector('[data-ot]');
        if (!r || !r.__ecOtState) return;
        var s = r.__ecOtState;
        if (!s.active) return;
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        s.submit(btn);
      }, true);

      document.addEventListener('click', function (e) {
        var t = e.target;
        if (!t || !t.closest) return;
        var pw = t.closest('[data-shopify="payment-button"]');
        if (!pw) return;
        if (pw.closest('.quick-product--wrap')) return;
        var h = pw.closest('.product__details');
        if (!h) return;
        var r = h.querySelector('[data-ot]');
        if (!r || !r.__ecOtState) return;
        var s = r.__ecOtState;
        if (!s.active) return;
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        s.buyItNow(pw);
      }, true);
    }

    function autoSelectHighest() {
      if (root.__ecOtAutoDone) return;
      root.__ecOtAutoDone = true;
      if (root.getAttribute('data-ot-auto-highest') !== '1') return;
      if (/[?&]variant=/.test(window.location.search)) return;
      if (!offers.length) return;
      var top = offers[offers.length - 1];
      var rd = root.querySelector('[data-ot-radio][value="' + top.i + '"]');
      if (!rd || rd.checked) return;
      rd.checked = true;
      rd.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { window.setTimeout(autoSelectHighest, 0); });
    } else {
      window.setTimeout(autoSelectHighest, 0);
    }
  })();
